/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActionConstraintHasAllValid } from "./ActionConstraintHasAllValid";
import { ActionConstraintHasSelection } from "./ActionConstraintHasSelection";
import { ActionConstraintHasData } from "./ActionConstraintHasData";
import { ActionConstraintHasColumnEnabled } from "./ActionConstraintHasColumnEnabled";
export const ActionConstraint = core.serialization
    .union("type", {
    hasAllValid: ActionConstraintHasAllValid,
    hasSelection: ActionConstraintHasSelection,
    hasData: ActionConstraintHasData,
    hasColumnEnabled: ActionConstraintHasColumnEnabled,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
